export const darkMode = 'darkMode';

export const isDarkMode = `.darkMode &`;
